<div class="container">
    <app-wizard [withClientSelection]="false" [showPricingSelection]="false" [price]="price" (onShipmentRequest)="onShipmentRequest($event)"
        (onShipmentPriceRequest)="onShipmentPriceRequest($event)"></app-wizard>
</div>